import depositGroups from "./depositGroups";

export default depositGroups;